import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import 'flag-icons/css/flag-icons.min.css';

const LANGUAGES = [
  { code: 'es', countryCode: 'es', name: 'Español' },
  { code: 'en', countryCode: 'gb', name: 'English' },
  { code: 'fr', countryCode: 'fr', name: 'Français' },
  { code: 'de', countryCode: 'de', name: 'Deutsch' },
];

const LanguageToggle = () => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const current = LANGUAGES.find(l => i18n.language?.startsWith(l.code)) || LANGUAGES[0];

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(o => !o)}
        className="flex items-center gap-1 px-2 py-2 bg-slate-800/50 border border-slate-700/50 rounded-lg hover:bg-slate-700/50 transition-all"
        title={current.name}
      >
        <span className={`fi fi-${current.countryCode} text-base`} />
        <svg className="w-3 h-3 text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {open && (
        <div className="absolute right-0 mt-1 bg-slate-800 border border-slate-700/50 rounded-lg shadow-xl z-50 overflow-hidden">
          {LANGUAGES.map(lang => (
            <button
              key={lang.code}
              onClick={() => { i18n.changeLanguage(lang.code); setOpen(false); }}
              className={`flex items-center gap-2 w-full px-4 py-2.5 text-sm text-left transition-colors hover:bg-slate-700/50 ${
                current.code === lang.code ? 'text-amber-400 bg-slate-700/30' : 'text-slate-300'
              }`}
            >
              <span className={`fi fi-${lang.countryCode} text-base`} />
              <span>{lang.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageToggle;
